export default "__VITE_ASSET__DIx$K5dL__"